@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Root {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  color: $color-grey-B;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 1em;
  padding: 5em;

  .Warning {
    padding-top: 0.2em;

    strong {
      color: $color-grey-A;
      font-weight: $font-weight-semibold;
    }
  }
}
